import React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

const Container = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #383e48;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  }

  .sleep-summary {
    .summary-content {
      color: #6d7d8c;
      line-height: 1.6;
    }

    .summary-bullets {
      margin-top: 12px;
      padding-left: 20px;

      li {
        margin-bottom: 8px;
        color: #6d7d8c;
        font-size: 14px;
      }
    }

    .insight-section {
      h4 {
        margin-bottom: 8px;
        color: #383e48;
        font-size: 14px;
        font-weight: 600;
      }

      p {
        margin-bottom: 16px;
        font-size: 14px;
      }
    }

    .divider {
      height: 1px;
      background: #e4e7eb;
      margin: 20px 0;
    }
  }

  .no-data {
    text-align: center;
    color: #9aa5b1;
    padding: 40px 0;
    font-style: italic;
  }
`

const ClientInsights = ({ sleepSummary, loading }) => {
  const renderSleepSummary = () => {
    if (loading) {
      return (
        <div className="loading-container">
          <Spin size="small" />
        </div>
      )
    }

    if (!sleepSummary || Object.keys(sleepSummary).length === 0) {
      return (
        <div className="no-data">
          No summary available
        </div>
      )
    }

    return (
      <div className="sleep-summary">
        <div className="summary-content">
          {sleepSummary.whats_working_well && (
            <div className="insight-section">
              <h4>What's Working Well</h4>
              <p>{sleepSummary.whats_working_well}</p>
            </div>
          )}

          {sleepSummary.whats_working_well && (sleepSummary.areas_for_attention || sleepSummary.action_plan) && (
            <div className="divider" />
          )}

          {sleepSummary.areas_for_attention && (
            <div className="insight-section">
              <h4>Areas for Attention</h4>
              <p>{sleepSummary.areas_for_attention}</p>
            </div>
          )}

          {sleepSummary.areas_for_attention && sleepSummary.action_plan && (
            <div className="divider" />
          )}

          {sleepSummary.action_plan && (
            <div className="insight-section">
              <h4>Action Plan</h4>
              <p>{sleepSummary.action_plan}</p>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <Container>
      <div className="section-title">
        Insights Summary
      </div>
      {renderSleepSummary()}
    </Container>
  )
}

export default ClientInsights
